export default "__VITE_ASSET__CcsqHnej__"